import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { routesConfig } from "./utils/routes";

const router = createBrowserRouter(routesConfig);

const App = () => <RouterProvider router={router} />;

export default App;
